import emergencyService from "@/services/emergency";
import router from "../../router/index";

export const state = {
    gridEmergencyListData: [],
    emergencyListData: [],
    gridEmergencySessionsListData: [],
    emergencySessionsListData: [],
    gridSessionData: [],
    sessionData: [],
    areasWithSession : [],
    activeSessionsData : [],
    activeSessionsCount: false,
  };
  
  export const actions = {
    async resetEmergencyListData({ commit }) {
      await commit("emergencyListData", null);
    },
    async resetEmergencySessionsListData({ commit }) {
      await commit("emergencySessionsListData", null);
    },
    async resetSessionData({ commit }) {
      await commit("sessionData", null);
    },

    fetchGridEmergencyListData() {
      return new Promise((resolve, reject) => {
        emergencyService.getGridEmergecyListData().then((data) => {
            resolve(data.data);
            // commit("setGridData", data);
        }).catch((err) => {
            reject(err);
        });
      });
    },
    async getAll({ commit, dispatch }, params) {
      commit("grid/setLoading", true, { root: true });
      commit("grid/setRecordsCount", null, { root: true });
      await dispatch("resetEmergencyListData");
      return new Promise((resolve, reject) => {
        emergencyService
          .getGridEmergecyListData(params)
          .then((data) => {
            resolve(data);
            console.log('logbook', data.data.data, params);
            commit("emergencyListData", data.data.data);
            commit("grid/setRecordsCount", data.data.count, { root: true });
            commit("grid/setLoading", false, { root: true });
          })
          .catch((err) => {
            commit("grid/setLoading", false, { root: true });
            reject(err);
          });
      });
    },
    fetchGridEmergencySessionsListData() {
      // commit("grid/setLoading", true, { root: true });
      return new Promise((resolve, reject) => {
        emergencyService.getGridEmergencySessionsListData().then((data) => {
            resolve(data);
            // commit("setGridEmergencySessionsData", data);
            // commit("grid/setLoading", false, { root: true });
        }).catch((err) => {
            reject(err);
        });
      });
    },
    async getAllEmergencySessions({ commit, dispatch }, params) {
      commit("grid/setLoading", true, { root: true });
      commit("grid/setRecordsCount", null, { root: true });
      await dispatch("resetEmergencySessionsListData");
      return new Promise((resolve, reject) => {
        emergencyService
          .getGridEmergencySessionsListData(params)
          .then((data) => {
            resolve(data);
            commit("emergencySessionsListData", data.data.data);
            commit("grid/setRecordsCount", data.data.count, { root: true });
            commit("grid/setLoading", false, { root: true });
          })
          .catch((err) => {
            commit("grid/setLoading", false, { root: true });
            reject(err);
          });
      });
    },
    async getSessionPage({ dispatch }, payload) {
      await dispatch("fetchSessionData", payload);
    },
    fetchSessionData({ commit }, payload) {
      commit("grid/setLoading", true, { root: true });
      return new Promise((resolve, reject) => {
        emergencyService.getEmergency(payload).then((data) => {
            resolve(data);
            commit("setSessionData", data);
            commit("grid/setLoading", false, { root: true });

            if (payload.redirect) router.push("/emergency-sessions/" + payload.name + "/" + payload.id);
        }).catch((err) => {
            reject(err);
        });
      });
    },
    async getAllSession({ commit, dispatch }, params) {
      commit("grid/setLoading", true, { root: true });
      commit("grid/setRecordsCount", null, { root: true });
      await dispatch("resetSessionData");
      return new Promise((resolve, reject) => {
        emergencyService.getEmergency(params)
          .then((data) => {
            resolve(data);
            commit("sessionData", data.data.data);
            commit("grid/setRecordsCount", data.data.count, { root: true });
            commit("grid/setLoading", false, { root: true });
          })
          .catch((err) => {
            commit("grid/setLoading", false, { root: true });
            reject(err);
          });
      });
    },
    startSession({ commit, dispatch }, payload) {
      commit("setLoadingStatus",false);
      return new Promise((resolve, reject) => {
        emergencyService
          .startSession(payload)
          .then((data) => {
            this._vm.$toast.success("Session Started");
            resolve(data);
            commit("modal/setModalState", true, { root: true });
            dispatch("fetchSessionData", {
              id : data.data.id, 
              name :data.data.name, 
              params: {
                sites :[],
                areas : []
              },
              redirect : true , 
            });
            dispatch("fetchGridEmergencySessionsListData");
            dispatch("fetchAreasWithSession");
            dispatch("fetchActiveSessionsData");
          })
          .catch((err) => {
            reject(err);
            this._vm.$toast.error(err.data.message?err.data.message:err.data.data);
          });
      });
    },
    endSession({ commit, dispatch }, payload) {
      commit("setLoadingStatus",false);
      return new Promise((resolve, reject) => {
        emergencyService
          .endSession(payload.id)
          .then((data) => {
            this._vm.$toast.success("Session Ended");
            resolve(data);
            dispatch("fetchGridEmergencySessionsListData");
            dispatch("fetchAreasWithSession");
            dispatch("fetchActiveSessionsData");
          })
          .catch((err) => {
            reject(err);
            this._vm.$toast.error(err.data.message?err.data.message:err.data.data);
          });
      });
    },
    changeUserStatusSession({ commit }, payload) {
      commit("setLoadingStatus",false);
      return new Promise((resolve, reject) => {
        emergencyService
          .changeUserStatusSession(payload)
          .then((data) => {
            this._vm.$toast.success("Status Updated");
            resolve(data);
            // dispatch("fetchSessionData",{id :payload.sessionId});
          })
          .catch((err) => {
            reject(err);
            this._vm.$toast.error(err.data.message?err.data.message:err.data.data);
          });
      });
    },

    fetchAreasWithSession() {
      return new Promise((resolve , reject ) => {
        emergencyService
          .getAreasWithSession()
          .then((data) => {
            // commit("setAreasWithSession", data.data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
          });
      });
    },
    fetchActiveSessionsData() {
      return new Promise((resolve , reject ) => {
        emergencyService
          .getActiveSessions()
          .then((data) => {
            // commit("setActiveSessionsData", data.data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
          });
      });
    },
    fetchIfHavePermissionWithSession({ commit }, id) {
      commit("setLoadingStatus",false);
      return new Promise((resolve, reject) => {
        emergencyService
        .havePermissionWithSession(id)
        .then((data) => {
            resolve(data);
        })
        .catch((err) => {
            reject(err);
            err.status != 401 && this._vm.$toast.error(err.message);
        });
      });
    },

    checkEndSessionPermission({ commit }, id) {
      commit("setLoadingStatus",false);
      return new Promise((resolve, reject) => {
        emergencyService
        .checkEndSessionPermission(id)
        .then((data) => {
            resolve(data);
        })
        .catch((err) => {
            reject(err);
            // err.status != 401 && this._vm.$toast.error(err.message);
        });
      });
    },

    setActiveSessionsCount({ commit }, count) {
      commit("setActiveSessionsCount", count);
    }
  };
  
  export const mutations = {
    setGridData(state, payload) {
    state.gridEmergencyListData = payload;
    },
    emergencyListData(state, payload) {
      state.emergencyListData = payload;
    },

    setGridEmergencySessionsData(state, payload) {
      state.gridEmergencySessionsListData = payload;
    },
    emergencySessionsListData(state, payload) {
      state.emergencySessionsListData = payload;
    },

    setSessionData(state, payload) {
      state.gridSessionData = payload;
    },
    sessionData(state, payload) {
      state.sessionData = payload;
    },
    setLoadingStatus(state, loading) {
      state.loadingStatus = loading;
    },
    setAreasWithSession(state, payload) {
      state.areasWithSession = payload;
    },
    setActiveSessionsData(state, payload) {
      state.activeSessionsData = payload;
    },
    setActiveSessionsCount(state, payload) {
      state.activeSessionsCount = payload;
    },
  }

  export const getters = {
    getGridEmergecyListData(state) {
      return state.gridEmergencyListData;
    },
    getGridEmergencySessionsListData(state) {
      return state.gridEmergencySessionsListData;
    },
    getSessionData(state) {
      return state.gridSessionData;
    },
    getAreasWithSession(state) {
      return state.areasWithSession;
    },
    getActiveSessionsData(state) {
      return state.activeSessionsData;
    },
    getActiveSessionsCount(state) {
      return state.activeSessionsCount;
    },
  };

